import { PrioritiesIncidents } from "../Widgets/PrioritiesIncidents";
import { SimpleAreaWidget } from "../Widgets/SimpleAreaWidget";
import { TextWidget } from "../Widgets/TextWidget";
import useFetchData from "../../utils/hooks/useFetchData";
import { SimpleBarWidget } from "../Widgets/SimpleBarWidget";
import Spinner from "../Global/Spinner";
import { HrHorizontal } from "../Global/HrHorizontal";
import { HrVertical } from "../Global/HrVertical";
import { Card } from "antd";

export const Water = () => {
  const { data: waterData } = useFetchData("/nova_wallboards/getwaterdata");
  
  if (waterData) {

    return (
      <>
        <div style={{ width: '33.3%' }}>
          <Card.Grid style={{ width: '100%', textAlign: 'center', height: '39%', padding: '5px' }}>
            <PrioritiesIncidents data={{
              red: waterData?.incidents?.red,
              orange: waterData?.incidents?.orange,
              yellow: waterData?.incidents?.yellow,
            }} />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', height: '56%', padding: '5px' }}>
            <TextWidget
              number={waterData?.waterGeneralConsume}
              unit="m³"
              unitMesure="/semana"
              label="CONSUMO GERAL" />
          </Card.Grid>
        </div>
        <HrVertical />
        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '20%', padding: '5px' }}>
            <TextWidget
              number={waterData?.totalWaterConsumeInWeek}
              unit="m³"
              unitMesure="/semana"
              label="CONSUMO EDIFÍCIOS" />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '75%', padding: '5px' }}>
            <SimpleBarWidget
              data={waterData?.consumeByBuildings}
              label="CONSUMO SEMANAL POR EDIFÍCIO  (m³)"
              layout="vertical"
              height="100%"
              name='m³' />
          </Card.Grid>
        </div>
        <HrVertical />
        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '48%', padding: '5px' }}>
            <SimpleAreaWidget
              label="CONSUMO NO DIA ANTERIOR  (m³)"
              data={waterData?.waterConsumePreviousDayChart}
              marginTop='10px'
              domain={[0, 'dataMax + 1']}
              name='m³' />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '48%', padding: '5px' }}>
            <SimpleAreaWidget
              label="CONSUMO DE ÁGUA (m³)"
              data={waterData?.waterConsumeWeekChart}
              marginTop='10px'
              domain={[0, 'dataMax + 1']}
              name='m³' />
          </Card.Grid>
        </div>
      </>
    );
  } else {
    return (
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </div>
    );
  }
};